const FETCH_CAMPAIGN = "v3/campaign/:partnerId/fetchCampaigns";
const ADD_CAMPAIGN = "v3/campaign/add";

const FETCH_CATEGORIES = (partnerId: string) =>
  `v3/campaign/${partnerId}/getcategories`;
const FETCH_PRODUCTS = (partnerId: string) =>
  `v3/campaign/${partnerId}/getproducts`;
const FETCH_BRANDS = (partnerId: string) =>
  `v3/campaign/${partnerId}/getbrands`;
const FETCH_COUNTRIES = (partnerId: string) =>
  `v3/campaign/${partnerId}/getcountries`;
const FETCH_CAMPAIGN_BY_ID = (campaignId: string) =>
  `v3/campaign/${campaignId}/get`;
const EDIT_CAMPAIGN = (campaignId: string) => `v3/campaign/${campaignId}/edit`;
const CHANGE_CAMPAIGN_STATUS = (campaignId: string) =>
  `v3/campaign/${campaignId}/changestate`;

export {
  ADD_CAMPAIGN,
  CHANGE_CAMPAIGN_STATUS,
  EDIT_CAMPAIGN,
  FETCH_BRANDS,
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_BY_ID,
  FETCH_CATEGORIES,
  FETCH_COUNTRIES,
  FETCH_PRODUCTS,
};
